// Thin retailer-side wrapper around the shared image lightbox. Centralises the
// "is this an image we can show in the lightbox?" rule so every gallery
// (plans, 3D renders, designs, photos, message attachments) treats files the
// same way — PDFs / DWG and other non-images keep their open-in-new-tab /
// download behaviour.
import { openLightbox, type LightboxImage } from "@tkos/shared-ui";

export { openLightbox };
export type { LightboxImage };

const IMG_EXT_RE = /\.(jpe?g|png|webp|gif|svg|avif)(?:[?#]|$)/i;

/** True for image URLs/filenames the lightbox can render (incl. data: images). */
export function isImageUrl(urlOrName: string | null | undefined): boolean {
  if (!urlOrName) return false;
  if (/^data:image\//i.test(urlOrName)) return true;
  return IMG_EXT_RE.test(urlOrName);
}
